import cloneDeep from 'lodash.clonedeep';

const ClassUtility = {
  // cloneObject: (obj) => Object.assign(Object.create(Object.getPrototypeOf(obj)), obj),
  cloneObject: (obj) => cloneDeep(obj),
};

export default ClassUtility;
